export enum CP_CONTRACTOR_TYPES {
  Seller = 1,
  Buyer = 2,
  Competitor = 3,
  Partner = 4,
  Potential = 5,
  Provider = 6,
  Factor = 8,
}
